import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	sideBarNavigationTitle: {
		id: 'spa-apps-sidebar-common.common.screen-reader-header.side-bar-navigation-title',
		defaultMessage: 'Menu',
		description: 'Hidden Sidebar navigation menu title for screen reader',
	},
});
